import { GetOrderDetailBankpayment, GetOrderDetailData } from "services/interface";
import { formatDateWithTime } from "utils/dateFormat";
import { Typography, Image, Divider } from "antd";
import { FC } from "react";
import { numberFormat } from "utils/nuberFormat";
import noImage from "assets/images/no-image.png";


interface CanceDetailLabelProps  {
    item: GetOrderDetailData | undefined;
}

const CanceDetailLabel:FC <CanceDetailLabelProps> =({
    item
}) => {
    return (
    <div style={{ padding: 30, backgroundColor:'#f9bfbf' }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
            <Typography.Text style={{ fontWeight: "400",whiteSpace:'nowrap' }}>
                เหตุผลการขอยกเลิก
            </Typography.Text>
            </div>
            <div style={{ flex: 1.5 }}>
                <Typography.Text>
                {item?.reason_cancel && item.reason_cancel}
                </Typography.Text>
            </div>
        </div>
        
        {/* <div style={{ display: "flex", flexDirection: "column" }} >
            <div style={{ flex: 1 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
                สลิป
            </Typography.Text>
            </div>
            {item?.image_slip && (
            <div style={{display: "flex",justifyContent: "center",}} >
                <Image
                width={180}
                src={`${item?.image_slip ?? noImage}`}
                />
            </div>
            )}
        </div> */}
        {/* <Divider/> */}
    </div>
    )
} 

export default CanceDetailLabel